import React, { useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';

const departments = [
    { "name": "परिचय", "id": "about" },
    { "name": "संचालित पाठ्यक्रम", "id": "courses" },
    { "name": "संकाय सदस्य", "id": "faculty" },
    { "name": "समय सारिणी", "id": "timetable" },
    { "name": "सुविधाएं", "id": "facilities" },
    { "name": "सेमीनार/सम्मेलन/कार्यशाला", "id": "events" },
    { "name": "शोधच्छात्र", "id": "researchScholars" },
    { "name": "उपलब्धियां", "id": "achievements" },
    { "name": "सम्पर्क", "id": "contact" }
];

const departmentContent = {
    "about": (
        <div>
            <p className="mb-2 text-justify">योग केवल शारीरिक अभ्यास नहीं बल्कि एक गहन विज्ञान और जीवनशैली है, जो शरीर, मन और आत्मा को संतुलित व समत्वमय करने की कला सिखाता है । यह भारत की समृद्ध वैविध्यपूर्ण ज्ञान परम्पराओं यथा – वैदिक, बौद्ध, जैन आदि का अभिन्न अंग रहा है, जिनकी जड़ें हजारों वर्ष पुरानी है ।</p>
            <p className="mb-2 text-justify">योग की महत्ता आज विज्ञान भी स्वीकार कर रहा है और आधुनिक चिकित्सा शोधों ने यह प्रमाणित किया है कि योग विभिन्न मानसिक व दैहिक विकारों के उपचार में सहायक है । लेकिन जनसाधारण में योग के इसी आरोग्यता केन्द्रित स्वरूप के प्रचलित होने के कारण इसकी व्यापकता अत्यन्त सीमित होकर रह गई है ।</p>
            <p className="mb-2 text-justify">श्री अरविन्द के शब्दों में – “योग का अर्थ केवल ईश्वर की प्राप्ति नहीं बल्कि आभ्यान्तर तथा बाह्य जीवन का ऐसा परिपूर्ण उत्सर्ग और परिवर्तन है कि उसके द्वारा भगवच्चैतन्य व्यक्त हो और वह स्वयं भगवत्कर्म का एक अंग हो” – इन अर्थों में योग को केवल एक व्यायाम व स्वास्थ्य की पद्धति भर न मानकर एक सम्पूर्ण जीवनदर्शन के रूप में देखना आवश्यक है ।</p>
            <p className="mb-2 text-justify">महर्षि वाल्मीकि संस्कृत विश्वविद्यालय, कैथल भारतीय संस्कृति, संस्कृत भाषा और ज्ञान परम्पराओं के संरक्षण व संवर्धन के लिए समर्पित एक प्रतिष्ठित संस्थान है । इसकी स्थापना हरियाणा सरकार द्वारा संस्कृत विश्वविद्यालय को स्थापित करने की योजना को साकार करने के क्रम में 2018 में की गई । इसकी स्थापना के समय से ही विश्वविद्यालय में योग विभाग की आवश्यकता को देखते हुए इसे प्रारम्भ से ही स्थान दिया गया । विश्वविद्यालय का योग विभाग – विज्ञान, दर्शन, प्रशिक्षण, अभ्यास व चिकित्सा के गहन अध्ययन व अनुसंधान को बढ़ावा देने के लिए प्रतिबद्ध है ।</p>
            <p className="mb-4 text-justify">योग विभाग का उद्देश्य केवल शारीरिक स्वास्थ्य तक सीमित नहीं है, बल्कि यह योग की पारम्परिक और वैज्ञानिक दृष्टिकोण को एकीकृत करके इसे समग्र रूप में प्रस्तुत करता है । यहाँ छात्रों को योग का शास्त्रीय अध्ययन कराया जाता है, ताकि उनको परम्परा के समृद्ध ज्ञान की छाप मिल सके, जिसमें उपनिषदों, श्रीमद्भगवद्गीता, पतंजलि, योगसूत्र, आयुर्वेद, प्राकृतिक चिकित्सा एवं भारतीय ज्ञान परम्पराओं से सम्बन्धित ग्रन्थों का अध्ययन शामिल है । इसके साथ ही आधुनिक विज्ञान, जैसे कि मानव शरीर रचना व क्रिया विज्ञान, व्यवहारिक मनोविज्ञान, भारतीय मनोविज्ञान, शोध व अनुसंधान से भी छात्रों को परिचित कराया जाता है । इसके अतिरिक्त योग विभाग नई शिक्षा नीति 2020 के सिद्धान्तों को अपनाते हुए कौशल व रोजगार आधारित शिक्षा को ध्यान में रखते हुए विद्यार्थियों को उसी अनुरूप पाठ्यक्रम को प्रेषित व प्रशिक्षित करता है ।</p>

            <h6 className="mb-3 ">विश्वविद्यालय के योग विभाग के प्रमुख उद्देश्य:</h6>
            <ol className="list-group list-group-numbered">
                <li className="list-group-item bg-transparent border-0">योग शिक्षा का प्रचार-प्रसार - छात्रों एवं समाज में योग की शास्त्रीय एवं वैज्ञानिक समझ विकसित करना तथा योग को जीवनशैली का अभिन्न अंग बनाना।</li>
                <li className="list-group-item bg-transparent border-0">शारीरिक, मानसिक एवं आध्यात्मिक विकास - विद्यार्थियों के संपूर्ण विकास के लिए योग के विभिन्न अंगों – आसन, प्राणायाम, ध्यान, यम-नियम आदि का अभ्यास कराना।</li>
                <li className="list-group-item bg-transparent border-0">शोध एवं नवाचार को प्रोत्साहन - योग से संबंधित शास्त्रीय ग्रंथों, आधुनिक विज्ञान और चिकित्सा के क्षेत्र में शोध को बढ़ावा देना और नये आयामों की खोज करना।</li>
                <li className="list-group-item bg-transparent border-0">प्रशिक्षित योग विशेषज्ञों का निर्माण - समाज की आवश्यकताओं के अनुरूप प्रशिक्षित योग शिक्षकों, योग चिकित्सकों एवं प्रशिक्षकों को तैयार करना।</li>
                <li className="list-group-item bg-transparent border-0">स्वास्थ्य एवं रोग निवारण में योग का प्रयोग - योग के माध्यम से जीवनशैली जनित रोगों की रोकथाम और उपचार हेतु जागरूकता फैलाना और विशेष शिविरों/कोर्सों का आयोजन करना।</li>
                <li className="list-group-item bg-transparent border-0">भारतीय सांस्कृतिक विरासत का संरक्षण - योग के माध्यम से भारतीय सांस्कृतिक मूल्यों और परंपराओं का संरक्षण एवं संवर्धन करना।</li>
                <li className="list-group-item bg-transparent border-0">रोजगारोन्मुखी शिक्षा का विकास - योग को एक व्यावसायिक विषय के रूप में प्रस्तुत कर रोजगार के नए अवसरों की सृष्टि करना।</li>
                <li className="list-group-item bg-transparent border-0">राष्ट्रीय और अंतरराष्ट्रीय सहयोग - योग के क्षेत्र में विभिन्न शैक्षणिक संस्थानों, स्वास्थ्य संगठनों तथा अंतरराष्ट्रीय मंचों से सहयोग स्थापित करना।</li>
            </ol>
        </div>
    ),
    "courses": (
        <div>
            <ul className="list-group list-group-flush">
                <li className="list-group-item bg-transparent border-0">बी.ए. (योग) – 04 वर्षीय</li>
                <li className="list-group-item bg-transparent border-0">एम.ए. (योग) – 02 वर्षीय</li>
                <li className="list-group-item bg-transparent border-0">डिप्लोमा (योग) – 01 वर्षीय</li>
            </ul>
        </div>
    ),
    "faculty": (
        <div className="mb-4">
            <h6 className="mb-3">1. कुल शिक्षक – 01</h6>
            <div className="table-responsive">
                <table className="table table-bordered table-striped table-hover align-middle small">
                    <thead className="table-primary text-center">
                        <tr>
                            <th>फोटो</th>
                            <th>आचार्य का नाम</th>
                            <th>पद</th>
                            <th>उच्चतम योग्यता</th>
                            <th>सम्पर्क</th>
                            <th>ई-मेल</th>
                        </tr>
                    </thead>
                    <tbody className="text-center">
                        <tr>
                            <td style={{ width: "120px" }}>
                                <img
                                    src={require("../assets/Photos/डॉ. देवेन्द्र सिंह (योग विभाग).jpg")}
                                    alt="डॉ. देवेन्द्र सिंह"
                                    className="img-fluid rounded"
                                    style={{ height: "100px", objectFit: "cover" }}
                                />
                            </td>
                            <td>डॉ. देवेन्द्र सिंह</td>
                            <td>प्रभारी, सहायक-आचार्य</td>
                            <td>पीएच.डी., नेट</td>
                            <td>9911872115</td>
                            <td>
                                <a href="mailto:hodyog@mvsu.ac.in">hodyog@mvsu.ac.in</a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    ),

    "timetable": (
        <div>
            <p className="text-muted">समय सारिणी की जानकारी जल्द ही उपलब्ध कराई जाएगी।</p>
        </div>
    ),
    "facilities": (
        <div>
            <ul className="list-group list-group-flush">
                <li className="list-group-item bg-transparent border-0"><strong className="text-secondary">व्यवस्थित योग प्रशिक्षण:</strong> विभाग में विद्यार्थियों को शास्त्रीय योग, आधुनिक योग चिकित्सा, मानव शरीर विज्ञान, मनोविज्ञान, दर्शन तथा योग साधना का समग्र ज्ञान प्रदान किया जाता है ।</li>
                <li className="list-group-item bg-transparent border-0"><strong className="text-secondary">योग भवन:</strong> छात्रों को अभ्यास व प्रशिक्षण के लिए सुव्यवस्थित योगा हॉल उपलब्ध है ।</li>
                <li className="list-group-item bg-transparent border-0"><strong className="text-secondary">प्राकृतिक चिकित्सा उपकरण:</strong> योग एवं प्राकृतिक चिकित्सा के समन्वय से उपचारात्मक विधियाँ सिखाने की व्यवस्था है ।</li>
                <li className="list-group-item bg-transparent border-0"><strong className="text-secondary">अनिवार्य योग शिविर:</strong> विद्यार्थियों में आत्मविश्वास बढ़ाने और उनके प्रशिक्षण कौशल को निखारने के लिए प्रत्येक सत्र में नियमित तीन दिवसीय योग शिविरों का आयोजन करवाया जाता है, जिससे छात्र योग कक्षा लेने में पारंगत हो सके ।</li>
                <li className="list-group-item bg-transparent border-0"><strong className="text-secondary">संस्कृत एवं भारतीय परम्परा का वातावरण:</strong> विश्वविद्यालय संस्कृत अध्ययन एवं भारतीय संस्कृति के संवर्धन हेतु समर्पित होने के कारण यहाँ योग भी अपनी पारम्परिक एवं शास्त्रीय जड़ों के साथ पढ़ाया जाता है । छात्रों को योग केवल व्यायाम के रूप में नहीं बल्कि भारत के समृद्ध ज्ञान व दर्शन परम्परा के मूल्यों के साथ जोडा जाता है ताकि छात्रों का व्यक्तित्व विकास भी साथ-साथ हो ।</li>
            </ul>
        </div>
    ),
    "events": (
        <div>
            <div className="table-responsive">
                <table className="table table-bordered table-striped small">
                    <thead className="table-dark">
                        <tr>
                            <th>व्याख्यानकर्त्ता/आधारपुरुष</th>
                            <th>कार्यक्रम</th>
                            <th>दिनाङ्क</th>
                            <th>विषय</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>डॉ. देवेन्द्र सिंह</td>
                            <td>कार्यशाला</td>
                            <td>19 मार्च 2024</td>
                            <td>योग के द्वारा तनाव प्रबन्धन</td>
                        </tr>
                        <tr>
                            <td>डॉ. देवेन्द्र सिंह</td>
                            <td>कार्यशाला</td>
                            <td>19 जून 2023</td>
                            <td>प्राकृतिक चिकित्सा की विधियों का ज्ञान</td>
                        </tr>
                        <tr>
                            <td>डॉ. देवेन्द्र सिंह</td>
                            <td>कार्यशाला</td>
                            <td>13-14 मार्च 2023</td>
                            <td>प्राकृतिक चिकित्सा के द्वारा विविध रोगों का प्रबन्धन</td>
                        </tr>
                        <tr>
                            <td>डॉ. देवेन्द्र सिंह</td>
                            <td>शिक्षक प्रशिक्षण कार्यक्रम</td>
                            <td>15-21 जुलाई 2023</td>
                            <td>सघन योग शिक्षक प्रशिक्षण कार्यशाला</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    ),
    "researchScholars": (
        <div>
            <p className="text-muted">शोधच्छात्र व विद्यावारिधि उपाधि हेतु पंजीकृत छात्र नहीं हैं।</p>
        </div>
    ),
    "achievements": (
        <div>
            <ul className="list-group list-group-flush">
                <li className="list-group-item bg-transparent border-0">योग विभाग की पुरुष टीम के छात्रों ने 23-28 दिसम्बर 2024 को KIIT, भुवनेश्वर में आयोजित AIU योगासन प्रतियोगिता में तृतीय स्थान (कांस्य पदक) प्राप्त किया । इस प्रतियोगिता में 415 विश्वविद्यालयों ने भाग लिया था ।</li>
                <li className="list-group-item bg-transparent border-0">हरियाणा उच्चतर शिक्षा विभाग की दिनांक 15-17 मार्च 2024 को राजकीय स्नातकोत्तर महिला महाविद्यालय, सैक्टर -14, पंचकूला में आयोजित राज्यस्तरीय योगासन प्रतियोगिता में योग विभाग की पुरुष टीम ने प्रथम स्थान तथा महिला टीम ने तृतीय स्थान प्राप्त किया । इसी प्रतियोगिता में योग विभाग के छात्र – भविष्य को सर्वश्रेष्ठ खिलाड़ी के रूप में चुना गया ।</li>
                <li className="list-group-item bg-transparent border-0">योग फेडरेशन ऑफ इण्डिया द्वारा आयोजित 47वीं वरिष्ठ राष्ट्रीय योग स्पोर्ट्स चैम्पियनशीप (जिसे राजस्थान योग स्पोर्टस संघ ने 25-28 मार्च 2023 के दौरान सम्पन्न कराया) में योग विभाग के छात्र गीतांशु (बी.ए. तृतीय वर्ष) ने वरिष्ठ समूह (18-35 वर्षीय) पुरुष वर्ग के अन्तर्गत कलात्मक युगल योग में द्वितीय स्थान, कलात्मक योगासन प्रतियोगिता में द्वितीय स्थान और सहज प्रवाह योगनृत्य में प्रथम स्थान प्राप्त किया ।</li>
                <li className="list-group-item bg-transparent border-0">योग फेडरेशन ऑफ इण्डिया द्वारा आयोजित 48वीं वरिष्ठ राष्ट्रीय योग स्पोर्ट्स चैंपियनशिप, जिसे पश्चिम बंगाल संघ ने 19-23 मार्च 2024 के दौरान संपन्न कराया, में महर्षि वाल्मीकि संस्कृत विश्वविद्यालय, कैथल, हरियाणा के बी.ए. योग तृतीय वर्ष के छात्र गीतांशु ने वरिष्ठ समूह (18 से 35 वर्षीय) पुरुष वर्ग के अंतर्गत लयबद्ध योग में द्वितीय स्थान, सहज प्रवाही योगप्रदर्शन में द्वितीय स्थान तथा वरिष्ठ समूह B (21-25 वर्षीय) पुरुष वर्ग के अंतर्गत योगासन प्रतियोगिता में द्वितीय स्थान प्राप्त किया।</li>
                <li className="list-group-item bg-transparent border-0">योग फेडरेशन ऑफ़ इंडिया द्वारा आयोजित 47वीं वरिष्ठ राष्ट्रीय योग स्पोर्ट्स चैंपियनशिप, जिसे राजस्थान योग स्पोर्ट्स संघ ने 25-28 मार्च 2023 के दौरान संपन्न कराया, में महर्षि वाल्मीकि संस्कृत विश्वविद्यालय, कैथल, हरियाणा की छात्रा सीमा ने वरिष्ठ समूह (18-35 वर्षीय) महिला वर्ग के अंतर्गत कलात्मक युगल योगासन प्रतियोगिता में प्रथम स्थान प्राप्त किया।</li>
                <li className="list-group-item bg-transparent border-0">बी.ए. योग के छात्र भविष्य ने अलमोड़ा, उत्तराखण्ड में आयोजित 38वीं राष्ट्रीय खेल प्रतियोगिता में पाँचवा स्थान प्राप्त करके ऐशियन खेलों में अपना स्थान पक्का किया ।</li>
                <li className="list-group-item bg-transparent border-0">बी.ए. योग के छात्र भविष्य ने 49वीं वरिष्ठ राष्ट्रीय योग फेडरेशन ऑफ इण्डिया द्वारा केरल में आयोजित प्रतियोगिता (आर्टिस्टिक सोलो) में प्रथम स्थान प्राप्त करके स्वर्ण पदक एवं ट्रेडिशनल में तीसरा स्थान प्राप्त करके कांस्य पदक जीता ।</li>
                <li className="list-group-item bg-transparent border-0">विश्वविद्यालय के योग विभाग के द्वारा अब तक लगभग 315 योग शिविरों का आयोजन किया जा चुका है ।</li>
            </ul>
            <div className="table-responsive">
                <table className="table table-bordered table-striped small">
                    <thead className="table-dark">
                        <tr>
                            <th>क्र.</th>
                            <th>कर्मचारी का नाम</th>
                            <th>पद</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>1.</td>
                            <td>श्री सीताराम</td>
                            <td>लिपिक (HKRN)</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    ),
    "contact": (
        <div>
            <p>सम्पर्क विवरण उपलब्ध नहीं है।</p>
        </div>
    )
};

export default function DepartmentYoga() {
    const [showSidebar, setShowSidebar] = useState(true);
    const [activeContentId, setActiveContentId] = useState("about");


    const getActiveSectionName = () => {
        const activeDept = departments.find(dept => dept.id === activeContentId);
        return activeDept ? activeDept.name : "योग विभाग अनुभाग";
    };

    const handleItemClick = (deptId) => {
        setActiveContentId(deptId);

        if (window.innerWidth < 768) {
            setShowSidebar(false);
        }
    };

    return (
        <div className="d-flex vh-100 flex-column flex-md-row bg-light">
            {/* छोटे स्क्रीन के लिए टॉगल बटन */}
            <button
                className="btn d-md-none m-2 shadow-sm text-white"
                onClick={() => setShowSidebar(!showSidebar)}
                style={{
                    backgroundColor: "#77236b",
                    borderColor: "#77236b"
                }}
            >
                ☰ मेनू
            </button>




            <aside className={`bg-white text-dark p-3 shadow-lg d-flex flex-column ${showSidebar ? "d-block" : "d-none"} d-md-flex col-md-3 border-end`}>
                <h5 className="text-center fw-bold mb-4 text-dark border-bottom pb-2">योग विभाग</h5>
                <nav className="flex-grow-1 overflow-auto pe-2">
                    {departments.map((dept) => (
                        <p
                            key={dept.id}
                            className={`mb-2 p-2 rounded small cursor-pointer transition-colors ${activeContentId === dept.id ? "text-white shadow-sm" : "bg-light text-dark hover-effect"}`}
                            onClick={() => handleItemClick(dept.id)}
                            style={{
                                cursor: "pointer",
                                backgroundColor: activeContentId === dept.id ? "#77236b" : undefined,
                                fontWeight: activeContentId === dept.id ? "bold" : "normal"
                            }}
                        >
                            {dept.name}
                        </p>
                    ))}
                </nav>
            </aside>


            <main className="flex-grow-1 p-4 bg-white shadow col-md-9 overflow-auto">

                <h4 className="mb-3  text-center" style={{ color: '#77236b' }}>{getActiveSectionName()}</h4>

                {departmentContent[activeContentId] || <p className="text-muted">कृपया किसी अनुभाग का चयन करें।</p>}
            </main>


            <style jsx>{`
                .transition-colors {
                    transition: background-color 0.3s ease, color 0.3s ease, box-shadow 0.3s ease;
                }
                .hover-effect:hover {
                    background-color: #e2e6ea !important; /* निष्क्रिय आइटमों के लिए होवर पर हल्का ग्रे */
                    color: #000 !important;
                }
                .cursor-pointer {
                    cursor: pointer;
                }
            `}</style>
        </div>
    );
}